<template>
  <div>
    <input
      v-for="(selectedRetouching, index) in selectedRetouchings"
      :key="index"
      :name="`RetouchingPackage_${selectedRetouching.offerPackageId}_${selectedRetouching.frameId}`"
      type="hidden"
      value="true"
    >
  </div>
</template>

<script>
export default {
  name: 'RetouchingInputs',
  props: {
    selectedRetouchings: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/RetouchingInputs.vue